import React from 'react';
import './Leftsidebar.css';

const Leftsidebar = () => {
  return (
    <div className="leftsidebar">
      {/* Placeholder sidebar component */}
    </div>
  );
};

export default Leftsidebar;
